import {
  CHARGER_NODE_TYPE,
  CONSTRAINT_NODE_TYPE,
  DYNAMIC_SOFT_CONSTRAINT_NODE_TYPE,
  LOAD_NODE_TYPE,
  LOAD_SOFT_CONSTRAINT_NODE_TYPE,
  MEASUREMENT_POINT_NODE_TYPE,
  POWER_SOFT_CONSTRAINT_NODE_TYPE,
} from '../../../../screens/PlazaView/components/constants';
import { AGGREGATION_INTERVAL_1MIN } from '../../../services/telemetry/constants/aggregations';

const LOAD_GRAPH_TYPE = 'loadGraph';
const POWER_GRAPH_TYPE = 'powerGraph';

export const PG_GRAPH_TYPES = {
  LOAD: LOAD_GRAPH_TYPE,
  POWER: POWER_GRAPH_TYPE,
};

export const TIME_SERIES_LOADING = 'TIME_SERIES_LOADING';

export const PG_NODES_TYPES = {
  CONSTRAINT: CONSTRAINT_NODE_TYPE,
  LOAD_SOFT_CONSTRAINT: LOAD_SOFT_CONSTRAINT_NODE_TYPE,
  POWER_SOFT_CONSTRAINT: POWER_SOFT_CONSTRAINT_NODE_TYPE,
  DYNAMIC_SOFT_CONSTRAINT: DYNAMIC_SOFT_CONSTRAINT_NODE_TYPE,
  CHARGER: CHARGER_NODE_TYPE,
  MEASURE: MEASUREMENT_POINT_NODE_TYPE,
  LOAD: LOAD_NODE_TYPE,
};

export const PG_EXTERNAL_TYPES = {
  TOTAL: 'TOTAL',
  NODES: 'NODES',
};

export const PG_CONSTRAINT_NODES_TYPES = [
  PG_NODES_TYPES.CONSTRAINT,
  PG_NODES_TYPES.POWER_SOFT_CONSTRAINT,
  PG_NODES_TYPES.LOAD_SOFT_CONSTRAINT,
  PG_NODES_TYPES.DYNAMIC_SOFT_CONSTRAINT,
];

export const PG_MEASUREMENTS = {
  LOAD: 'CURRENT',
  POWER: 'POWER',
};

export const MINUTE_IN_MS = 60000;
export const DEFAULT_INTERVAL = AGGREGATION_INTERVAL_1MIN;
export const PERIOD_FOR_HISTORY = 3;

export const graphTypeOptions = [
  { label: 'Load Graph', value: PG_GRAPH_TYPES.LOAD },
  { label: 'Power Graph', value: PG_GRAPH_TYPES.POWER },
];

export const AVAILABLE_NODE_TYPES = [
  PG_NODES_TYPES.CHARGER,
  PG_NODES_TYPES.POWER_SOFT_CONSTRAINT,
  PG_NODES_TYPES.LOAD_SOFT_CONSTRAINT,
  PG_NODES_TYPES.CONSTRAINT,
  PG_NODES_TYPES.LOAD,
  PG_NODES_TYPES.MEASURE,
];
